if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              // soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      fetchCartContents() {
        fetch(
          `${routes.cart_url}?sections=${this.cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(",")}`
        )
          .then((response) => response.json())
          .then((response) => {
            console.log("Fetched cart contents:", response);
            this.cart.renderContents(response);
          })
          .catch((error) => {
            console.error("Error fetching cart contents:", error);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = "This collection is currently only available for sale in the U.S and Canada";
        }
      }
    }
  );
}

// if (!customElements.get("product-form-subscription-bundle")) {
//   customElements.define(
//     "product-form-subscription-bundle",
//     class ProductFormSubscriptionBundle extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector("form");
//         this.form.querySelector("[name=id]").disabled = false;
//         this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
//         this.cart =
//           document.querySelector("cart-notification") ||
//           document.querySelector("cart-drawer");
//         this.submitButton = this.querySelector('[type="submit"]');

//         if (document.querySelector("cart-drawer"))
//           this.submitButton.setAttribute("aria-haspopup", "dialog");

//         this.hideErrors = this.dataset.hideErrors === "true";
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute("aria-disabled") === "true") return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute("aria-disabled", true);
//         this.submitButton.classList.add("loading");

//         this.querySelector(".loading__spinner").classList.remove("hidden");

//         const config = fetchConfig("javascript");
//         config.headers["X-Requested-With"] = "XMLHttpRequest";
//         delete config.headers["Content-Type"];

//         // let nextIndex = 0;
//         // for (let i = 0; i < Cart.items.length; i++) {
//         //   let currentIndex = Cart.items[i].properties["_dynamicBoxIndex"];
//         //   console.log(nextIndex);
//         //   console.log(currentIndex);

//         //   if (nextIndex <= currentIndex) {
//         //     nextIndex = currentIndex + 1;
//         //   }
//         // }

//         let formData;

//         // let purchaseType = document.querySelector(".purchase-option.active")
//         //   .dataset.type;

//         // purchaseType === "subscription"
//         //   ? (formData = {
//         //       items: [
//         //         {
//         //           id: 44401619173601,
//         //           quantity: 1,
//         //           properties: {
//         //             _dynamicBoxId: "93d230df-f9fd-4e86-b9c1-1a61b75f45bf",
//         //             _dynamicBoxIndex: nextIndex,
//         //             _bundle_offer: "starter_bundle",
//         //             _bundle_id: nextIndex,
//         //           },
//         //           selling_plan: 4283662561,
//         //         },
//         //         {
//         //           id: 44401619042529,
//         //           quantity: 1,
//         //           properties: {
//         //             _dynamicBoxId: "93d230df-f9fd-4e86-b9c1-1a61b75f45bf",
//         //             _dynamicBoxIndex: nextIndex,
//         //             _bundle_offer: "starter_bundle",
//         //             _bundle_id: nextIndex,
//         //           },
//         //           selling_plan: 4283662561,
//         //         },
//         //         {
//         //           id: 44401618157793,
//         //           quantity: 1,
//         //           properties: {
//         //             _dynamicBoxId: "93d230df-f9fd-4e86-b9c1-1a61b75f45bf",
//         //             _dynamicBoxIndex: nextIndex,
//         //             _bundle_offer: "starter_bundle",
//         //             _bundle_id: nextIndex,
//         //           },
//         //           selling_plan: 4283662561,
//         //         },
//         //         {
//         //           id: 44949375058145,
//         //           quantity: 1,
//         //           properties: {
//         //             _bundle_offer: "starter_bundle",
//         //             _bundle_id: nextIndex,
//         //           },
//         //         },
//         //       ],
//         //     })
//         //   : (formData = {
//         //       items: [
//         //         {
//         //           id: 44401619173601,
//         //           quantity: 1,
//         //           properties: {
//         //             _dynamicBoxId: "93d230df-f9fd-4e86-b9c1-1a61b75f45bf",
//         //             _dynamicBoxIndex: nextIndex,
//         //             _bundle_offer: "starter_bundle",
//         //             _bundle_id: nextIndex,
//         //           },
//         //         },
//         //         {
//         //           id: 44401619042529,
//         //           quantity: 1,
//         //           properties: {
//         //             _dynamicBoxId: "93d230df-f9fd-4e86-b9c1-1a61b75f45bf",
//         //             _dynamicBoxIndex: nextIndex,
//         //             _bundle_offer: "starter_bundle",
//         //             _bundle_id: nextIndex,
//         //           },
//         //         },
//         //         {
//         //           id: 44401618157793,
//         //           quantity: 1,
//         //           properties: {
//         //             _dynamicBoxId: "93d230df-f9fd-4e86-b9c1-1a61b75f45bf",
//         //             _dynamicBoxIndex: nextIndex,
//         //             _bundle_offer: "starter_bundle",
//         //             _bundle_id: nextIndex,
//         //           },
//         //         },
//         //         {
//         //           id: 44949375058145,
//         //           quantity: 1,
//         //           properties: {
//         //             _bundle_offer: "starter_bundle",
//         //             _bundle_id: nextIndex,
//         //           },
//         //         },
//         //       ],
//         //     });

//         if (this.cart) {
//           formData["sections"] = this.cart
//             .getSectionsToRender()
//             .map((section) => section.id);

//           formData["sections_url"] = window.location.pathname;
//           this.cart.setActiveElement(document.activeElement);
//         }
//         console.log(formData);
//         config.body = JSON.stringify(formData);

//         fetch(window.Shopify.routes.root + "cart/add.js", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         })
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               this.handleErrorMessage(response.description);

//               this.submitButton.setAttribute("aria-disabled", true);
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }
//             if (!this.error) this.error = false;
//             this.cart.renderContents(response);
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove("loading");
//             this.querySelector(".loading__spinner").classList.add("hidden");
//             if (this.cart && this.cart.classList.contains("is-empty"))
//               this.cart.classList.remove("is-empty");
//             if (!this.error) this.submitButton.removeAttribute("aria-disabled");

//             document.querySelector("cart-drawer").updateCartObject();
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper ||
//           this.querySelector(".product-form__error-message-wrapper");
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage =
//           this.errorMessage ||
//           this.errorMessageWrapper.querySelector(
//             ".product-form__error-message"
//           );

//         this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }
//     }
//   );
// }
